// TODO: (josh) this Toolbar and toolbar config really stinks -
// really need to find a better to general way to construct a toolbar configuration

import React from 'react';
import { EditorState } from 'draft-js';

// Constants
import ToolbarConfig, { TOOLBAR_TYPE } from './toolbar.config';

// Components
import Inline from '../controls/Inline/Inline';
import List from '../controls/List/List';
import Emoji from '../controls/Emoji/Emoji';
import Gif from '../controls/Gif/Gif';
import { WpButtonGroup } from '../../button';

// Styles
import './Toolbar.scss';

type Props = {
  editorState: EditorState;
  onChange?: Function;
  isEmojiDropdownOpen: boolean;
  isGifPickerOpen: boolean;
  handleOpenEmojiMartDropdownChange: Function;
  handleGifPickerDropdownChange: Function;
  emojiMartDropdownRef: React.Ref<HTMLButtonElement>;
  gifPickerRef: React.Ref<HTMLButtonElement>;
};

const Toolbar = ({
  editorState,
  onChange,
  isEmojiDropdownOpen,
  handleOpenEmojiMartDropdownChange,
  isGifPickerOpen,
  handleGifPickerDropdownChange,
  gifPickerRef,
  emojiMartDropdownRef,
}: Props) => {
  const inlineControls = ToolbarConfig.filter(item => item.type === TOOLBAR_TYPE.inline);
  const listControls = ToolbarConfig.filter(item => item.type === TOOLBAR_TYPE.list);
  const advancedControls = ToolbarConfig.filter(item => item.type === TOOLBAR_TYPE.advanced);
  const baseClassName = 'Toolbar';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__group`}>
        <WpButtonGroup spacing="sm">
          {inlineControls.map(control => (
            <Inline
              key={`${toolbar}-${control.style}`}
              editorState={editorState}
              onChange={onChange}
              style={control.style}
            />
          ))}
        </WpButtonGroup>
      </div>
      <div className={`${baseClassName}__group`}>
        <WpButtonGroup spacing="sm">
          {listControls.map(control => (
            <List
              key={`${toolbar}-${control.block}`}
              editorState={editorState}
              onChange={onChange}
              block={control.block}
            />
          ))}
        </WpButtonGroup>
      </div>
      <div className={`${baseClassName}__group`}>
        <WpButtonGroup spacing="sm">
          {advancedControls.map(control => {
            switch (control.block) {
              case 'emoji':
                return (
                  <Emoji
                    key={`${toolbar}-${control.block}`}
                    block={control.block}
                    isEmojiDropdownOpen={isEmojiDropdownOpen}
                    handleOpenEmojiMartDropdownChange={handleOpenEmojiMartDropdownChange}
                    ref={emojiMartDropdownRef}
                  />
                );
              case 'gif':
                return (
                  <Gif
                    key={`${toolbar}-${control.block}`}
                    block={control.block}
                    isGifPickerOpen={isGifPickerOpen}
                    handleGifPickerDropdownChange={handleGifPickerDropdownChange}
                    ref={gifPickerRef}
                  />
                );
              default:
                return null;
            }
          })}
        </WpButtonGroup>
      </div>
    </div>
  );
};

export default Toolbar;
